export const RecordTypeCategories = [   
    {
        value: 'A',
        description: 'Receipts',
    },
    {
        value: 'B',
        description: 'Expenditures',
    },
    {
        value: 'C',
        description: 'Inkinds',
    },
    {
        value: 'D',
        description: 'Liabilities',
    },
    {
        value: 'SV',
        description: 'Suvendor Report Summaries',
    },
    {
        value: '951',
        description: 'Subvendor Report Items',
    },
    {
        value: 'R',
        description: 'Reimbursement Summaries',
    },
    {
        value: '351',
        description: 'Reimbursement Items',
    },
    {
        value: 'CC',
        description: 'Credit Card Summaries',
    },
    {
        value: '354',
        description: 'Credit Card Charges',
    },
    {
        value: '102',
        description: 'Periodic (102) Reports',
    },
    {
        value: '801',
        description: 'Bank Credits',
    },
    {
        value: '105',
        description: 'Bank Reports',
    },
    {
        value: '106',
        description: 'Deposit Reports',
    },
    {
        value: '107',
        description: 'Late Contribution Reports',
    },
    {
        value: '108',
        description: 'D102s',
    },
    {
        value: '110',
        description: 'Reimbursement Reports',
    },
    {
        value: '111',
        description: 'CPF9 Reports',
    },
    {
        value: '112',
        description: 'Subvendor Reports',
    }
]

export default RecordTypeCategories